import React, {useState} from 'react';
import Checkbox from "@material-ui/core/Checkbox";
import { tableStyles, trStyles, rowStyles, headerStyles } from './styles';
import { DAYOFWEEK_LABEL, DAYOFWEEK_DEFAULT } from '../../Dialogs/FormSettings/constants';

export default (props) => {
    let { value, disabled } = props;
    if (!value) value = DAYOFWEEK_DEFAULT;

    const [selectedDays, setSelectedDays] = useState(value)
    const daysOfWeek = DAYOFWEEK_LABEL;
    const getChecked = (dayNumber) => {return selectedDays.find(day => day === dayNumber) ? true : false;};
    const handleSelectDay = (checked, value) => {
        let newDays = selectedDays;
        if (checked) {
            newDays = newDays.concat(value);
        } else {
            const index = newDays.findIndex(day => day === value);
            if (index >= 0) newDays.splice(index, 1);
        }
        newDays.sort();
        setSelectedDays(newDays);
        const name = props.name || '';
        props.onDaySelect({days:newDays, name:name});
    }

    return (
        <>
        <table style={tableStyles}>
            <tbody>
                <tr style={trStyles}>
                    {daysOfWeek.map(day => <td style={headerStyles} key={day}>{day}</td>)}
                </tr>
                <tr>
                {daysOfWeek.map((day, index) => {
                    const dayNumber = index + 1;
                    const isChecked = getChecked(dayNumber);
                    return (
                        <td key={dayNumber} style={rowStyles}>
                            <Checkbox
                                checked={isChecked}
                                onChange={(ev) => handleSelectDay(ev.target.checked, dayNumber)}
                                disabled={disabled}
                            />
                        </td>
                    )
                })}
                </tr>
            </tbody>
        </table>
        </>
    )
}


